import {useState, useContext, useEffect} from "react";
import {langContext} from "commons/contexts";
import {useRouteMatch, Switch, Route} from "react-router-dom";

import NewsItem from "./Components/NewsItem";
import News from "./News";

import style from "./style.module.scss";
import textNl from "./newsText/nl";
import textFr from "./newsText/fr";

const texts: Record<string, Record<string, Record<string, string>>> = {
    nl: textNl,
    fr: textFr
}

function NewsList() {
    const {lang} = useContext(langContext);
    const { path}: {params: Record<string, string>, path: string} = useRouteMatch();

    const [text, setText] = useState<Record<string, Record<string, string>>>((texts[lang]) || {});


    useEffect(() => {
        setText(texts[lang] || {});
    }, [lang]);


    const items: string[] = ["region", "lifestyle", "purchases"];


    // var data = [
    //     {
    //         title: "Facere aut illo eos repellendus et explicabo iste? Rem odit culpa ab accusantium.",
    //         date: "11.07.2021",
    //         subtitle: "Lorem ipsum dolor sit amet consectetur, adipisicing elit.",
    //         text: " Id asperiores itaque architecto unde, quia est facilis rerum illo libero provident placeat voluptates odit eaque dolor, inventore harum? Nihil, architecto doloremque!",
    //         path: "exclusive",
    //         image: "/media/images/news/1.jpg"
    //     },
    //     {
    //         title: "Quia est facilis rerum illo libero provident placeat voluptates ",
    //         date: "03.07.2021",
    //         text: "voluptates odit eaque dolor, inventore harum? Nihil, architecto doloremquevoluptates odit eaque dolor,facere aut illo eos repellendus et explicabo iste? Rem odit culpa ab accusantium.inventore harum? Nihil, architecto doloremquevoluptates odit eaque dolor, inventore harum? Nihil, architecto doloremque",
    //         path: "patrimi",
    //         image: "/media/images/news/2.jpg"
    //     },
    //     {
    //         title: "Millo libero provident placeatasperiores itaque",
    //         date: "18.06.2021",
    //         text: "asperiores itaque architecto unde, quia est facilis rerum illo libero provident placeatasperiores itaque architecto unde, quia est facilis rerum illo libero provident placeat ",
    //         path: "spaansewaar",
    //         image: "/media/images/news/3.jpg"
    //     }
    // ];

    return (
        <Switch>
            <Route path={path + "/:news"}>
                <News />
            </Route>
            <Route path={path}>
                <div className={style.news_container}>
                    <div className={style.news_grid}>
                        {
                            items.map((item, i) => <NewsItem order={i % 2} data={{...text[item], path: item}} />)
                        }
                    </div>
                </div>
            </Route>
        </Switch>
    );
}

export default NewsList;